/**
 * `/api/dashboard` — the caller's own dashboard layout.
 *
 * A session and no permission, like your own inbox: everybody has a dashboard.
 * Nothing here takes a user id. The person is the session.
 *
 * **The server does not know the card catalogue.** Card types, their settings
 * and their size limits are declared in the frontend, so `type`, `config` and
 * `defaultKey` are stored as the client sent them, checked only for shape and
 * size. The frontend reads its own config as untrusted and clamps every width
 * to the card type's limits.
 */
/** The bounds `PUT /api/dashboard/layout` enforces. */
export const DASHBOARD_LIMITS = {
    /** Cards in one layout, hidden ones included. */
    CARDS: 100,
    TYPE_LENGTH: 100,
    DEFAULT_KEY_LENGTH: 100,
    /** One card's `config`, as JSON, in bytes. */
    CONFIG_BYTES: 2048,
    /** A width is a number of columns, from 1 to this. */
    COLUMNS: 3,
};
//# sourceMappingURL=dashboard.js.map